import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button, ButtonGroup } from 'app/src/elements/buttons';
import {
  Fields,
  defaultValues,
  prepareInput,
} from 'app/src/elements/hookForms';

import { CREATE_PAYMENT_TERM } from './queries';

export const FIELDS = {
  name: {
    rules: { required: true },
  },
  days: {
    type: 'int',
    rules: { required: true },
  },
};

const NewPaymentTerm = ({ setShowModal, refetch }) => {
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const [createPaymentTerm] = useMutation(CREATE_PAYMENT_TERM, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setFormStatus('submitting');
    createPaymentTerm({ variables: prepareInput(input, FIELDS) });
  });

  return (
    <View>
      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      <ButtonGroup>
        <Button label="Create Payment Term" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default NewPaymentTerm;
